import chunk from 'lodash/chunk';

import { pilot } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

interface Request {
  ids: Uuid[];
}

interface Response {
  count: number;
  next: string | null;
  previous: string | null;
  results: {
    id: Uuid;
    name: string;
  }[];
}

interface Clause {
  id: Uuid;
  label: string;
}

const CLAUSE_IDS_CHUNK_SIZE = 100;

const fetchClausesByIds = async (ids: Uuid[]): Promise<Clause[]> => {
  const response: Response = await pilot.get('/clause/', {
    params: {
      ids: ids.join(','),
      limit: ids.length,
    },
  });

  return response.results.map((clause) => ({
    id: clause.id,
    label: clause.name,
  }));
};

export const getClausesByIds = async ({
  ids,
}: Request): Promise<{ results: Clause[] }> => {
  const uniqueIds = [...new Set(ids)];

  if (uniqueIds.length === 0) {
    return { results: [] };
  }

  if (uniqueIds.length <= CLAUSE_IDS_CHUNK_SIZE) {
    return { results: await fetchClausesByIds(uniqueIds) };
  }

  const responses = await Promise.all(
    chunk(uniqueIds, CLAUSE_IDS_CHUNK_SIZE).map(fetchClausesByIds),
  );

  return { results: responses.flat() };
};
